let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ewZTP")).then(() => parcelRequire('g0mXN'));